<template>
  <UCard class="w-full h-full bg-(--color-background) text-(--color-text) ring-0 overflow-y-auto">
    <div class="flex flex-col h-full">
      <div class="flex-shrink-0">
        <ConfigurationForm />
      </div>
    </div>
    <ChartContainer />
    <!-- <iframe :src="`/preview${route.href}`" class="w-full h-full"></iframe> -->
  </UCard>
</template>
